module.exports = __webpack_public_path__ + "static/media/gov-1.bc7c940c.png";